var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-multifile"},[_c('vue-dropzone',{ref:"uploader",attrs:{"id":_vm._uid.toString(),"options":_vm.options},on:{"vdropzone-file-added":_vm.upload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }